import React, { useState }  from 'react';
import CurrencySelector from './CurrencySelector';
import ExampleTicket from './ExampleTicketPresentation';
import PaypalButton from './PaypalCheckoutButton';
import * as constClass from '../../constants/agent.js';
import { FlightTicket } from '../../utils/requests';

import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Collapse from 'react-bootstrap/Collapse';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import { useNavigate } from "react-router-dom";


function PayWhatYouWantCheckout(props) {
  //////////////////////////////////////////////////////////
  // State
  const [tabKey, setTabKey] = useState('pro');
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingStripe, setIsLoadingStripe] = useState(false);
  const [isLoadingCoinbase, setIsLoadingCoinbase] = useState(false);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("");

  // State Pro Ticket
  const [extraPassengers, setExtraPassengers] = useState([{"name": ""}]);
  const [currency, setCurrency] = useState("");
  const [optionalPnrNumber, setOptionalPnrNumber] = useState("");
  const [flightClass, setFlightClass] = useState("economy");
  const [openProSettings, setOpenProSettings] = useState(false);
  //////////////////////////////////////////////////////////

  // Routing
  const navigate = useNavigate();

  //////////////////////////////////////////////////////////
  // Functions

  const handleDonateButtonClick = () => {
    setTabKey("pro");
    setAlertType("success");
  }

  const handleCheckout = async (checkoutType) => {
      setIsLoading(true);
      // Customer data
      const {
        first_name,
        last_name,
        email,
        birthdate} = props.customer_data;
      // Flight data
      const {
        airline,
        arrival_time,
        city_from,
        city_to,
        departure_time,
        flight_name,
        fly_duration,
        fly_from,
        fly_to,
        price,
        route} = props.flight_data;
      // Extra data
      const {
        subscribe_to_newsletter
      } = props.extra_data;

    // Free option
    if (checkoutType === "free") {
      // POST to free endpoint
      console.log("Receiving free ticket")
      const response = await FlightTicket.orderTicketFree(
        first_name,
        last_name,
        email,
        birthdate,
        airline,
        arrival_time,
        city_from,
        city_to,
        departure_time,
        flight_name,
        fly_duration,
        fly_from,
        fly_to,
        price,
        route,
        subscribe_to_newsletter
      )
      //console.log("Received free ticket")
      if (response.status === 200) {
        // Navigate to success page
        navigate("/checkout-success", {state : { email: email }})
      } else if (response.status === 429) {
        // Rate limit reached
        const msg = 
        <div className="text-center">
          <Button variant="light" onClick={() => handleDonateButtonClick()}>
            <span className="badge badge-light">Get Pro Ticket</span>
          </Button>
          <hr/>
          You've hit the limit of free tickets for today (2/day).
        </div>
        setAlertType("warning");
        setAlertMessage(msg);
        setShowAlert(true);
        //navigate("/error", {state : { error_msg: response.statusText }})
      }
    }
    // Payment option
    else if (checkoutType === "stripe") {
        console.log("[*] Stripe Checkout")
        setIsLoadingStripe(true);
        // POST to create stripe checkout session
        const response = await FlightTicket.orderTicketStripe(
          first_name,
          last_name,
          email,
          birthdate,
          airline,
          arrival_time,
          city_from,
          city_to,
          departure_time,
          flight_name,
          fly_duration,
          fly_from,
          fly_to,
          price,
          route,
          subscribe_to_newsletter,
          "5", // 5 times 1$ ticket price
          // Pro ticket extra options
          extraPassengers,
          currency,
          optionalPnrNumber,
          flightClass
        )
        
        // ToDo implement status code handling here!
        // Otherwise I fail here if django doesn't return 200
        // Also set isLoadingStripe to false if django doesn't return 200
        // Receive stripe checkout URL from django
        const stripe_checkout_redirect_url = await response.json();
        setIsLoadingStripe(false);
        // Redirect to stripe checkout
        window.open(stripe_checkout_redirect_url);
    }
    else if (checkoutType === "coinbase") {
        console.log("[*] Coinbase Checkout")
        setIsLoadingCoinbase(true);
        // POST to create Coinbase charge
        const response = await FlightTicket.orderTicketCoinbase(
          first_name,
          last_name,
          email,
          birthdate,
          airline,
          arrival_time,
          city_from,
          city_to,
          departure_time,
          flight_name,
          fly_duration,
          fly_from,
          fly_to,
          price,
          route,
          subscribe_to_newsletter,
          "5", // 5 times 1$ ticket price
          // Pro ticket extra options
          extraPassengers,
          currency,
          optionalPnrNumber,
          flightClass
        )
        // ToDo implement status code handling here!
        // Otherwise I fail here if django doesn't return 200
        // Also set isLoadingCoinbase to false if django doesn't return 200
        // Receive coinbase checkout URL from django
        const coinbase_checkout_redirect_url = await response.json();
        setIsLoadingCoinbase(false);
        // Redirect to stripe checkout
        window.open(coinbase_checkout_redirect_url);
    }
    setIsLoading(false);
  }

  /////////////////////////
  // Pro Ticket Functions
  const handleAddPassenger = () => {
    // Allow max 5 extra passengers
    if (extraPassengers.length < 5) {
      setExtraPassengers([...extraPassengers, {"name": ""}]);
    }
  };

  const handlePassengerChange = (event, index) => {
    const newPassengers = [...extraPassengers];
    newPassengers[index] = {"name": event.target.value};
    setExtraPassengers(newPassengers);
  };

  const handleDeletePassenger = (index) => {
    const newPassengers = [...extraPassengers];
    newPassengers.splice(index, 1);
    setExtraPassengers(newPassengers);
  }

  const handleCurrencyChange = (event) => {
    setCurrency(event.target.value);
  }

  const handleFlightClassChange = (event) => {
    const selectedFlightClassText = event.target.options[event.target.selectedIndex].text;
    setFlightClass(selectedFlightClassText);
  }

  const handleOptionalPnrNumberChange = (event) => {
    setOptionalPnrNumber(event.target.value);
  }

  //////////////////////////////////////////////////////////


  ////////////////////////////////////////////////
  // JSX Components
  const free_ticket =
  <>
    <div className="row">
      <div className="col-lg-6">
        <ul className="list-unstyled text-left text-secondary">
          <li className="text-dark"><i className="bi bi-check text-success"></i> Real flight data</li>
          <li><i className="bi bi-x text-warning"></i> Airline logos in ticket</li>
          <li><i className="bi bi-x text-warning"></i> Add additional passengers</li>
          <li><i className="bi bi-x text-warning"></i> Choose currency on ticket</li>
          <li><i className="bi bi-x text-warning"></i> Choose flight class</li>
        </ul>
      </div>
      <div className="col-lg-6">
        <ExampleTicket
          headline="Basic Ticket:"
          ticketImage="/images/basic_ticket.png"
        />
      </div>
    </div>
  </>

  const pro_ticket_custom_settings = 
  <>
    <Button onClick={() => setOpenProSettings(!openProSettings)} variant="link" size="lg">
    <span className="font-weight-bold">Customize Settings {openProSettings ?<i className="bi bi-chevron-up"></i>:<i className="bi bi-chevron-down"></i>}<i className="bi bi-star-fill text-warning" /></span>
    </Button>
    <Collapse in={openProSettings}>
      <div>
        <div className="row mt-4">
          <div className="col">
            <p className="text-left">
              <span className="font-weight-bold mr-2">Extra Passengers</span>
              <span className="text-secondary text-sm">(optional) </span>
              <span class="badge badge-success">max 5</span>
            </p>
            <div className="form-group">
            {extraPassengers.map((passenger, index) => (
              <div className="input-group mb-2">
                <input
                    type="text"
                    id="extraPassenger"
                    value={passenger.name}
                    onChange={(e) => handlePassengerChange(e, index)}
                    className="form-control"
                    placeholder="Full Name"
                    maxLength="150"
                  />
                  <div className="input-group-prepend">
                    <button className="btn btn-light" onClick={() => handleDeletePassenger(index)}>
                      <i className="bi bi-x text-warning"></i>
                    </button>
                  </div>
              </div>
              ))}
            </div>
            {extraPassengers.length < 5 &&
            <button type="button" className="btn btn-outline-secondary btn-block" onClick={handleAddPassenger}>
              <i className="bi bi-plus"></i> Add Passenger
            </button>
            }
          </div>
        </div>

        <hr/>

        <div className="row">
          <div className="col text-left">
            <CurrencySelector currency={currency} onCurrencyChange={handleCurrencyChange} />
          </div>
          
          {/*
          <div className="col text-left">
            <label for="optionalPnrNumber">PNR Number <i class="bi bi-info-circle-fill" data-toggle="tooltip" data-placement="right" title="This is a tooltip"></i> <span className="text-secondary text-sm">(optional)</span></label>
            <input
            type="text"
            id="optionalPnrNumber"
            onChange={(e) => handleOptionalPnrNumberChange(e)}
            value={optionalPnrNumber}
            className="form-control"
            placeholder="PNR Number"
            maxLength="13"
            />
          </div>
          */}
        </div>

        <div className="row mb-3">
          <div className="col text-left">
            <label for="flightClass">Flight Class <span className="text-secondary text-sm">(optional)</span></label>
            <select
              type="text"
              id="flightClass"
              onChange={(e) => handleFlightClassChange(e)}
              className="form-control"
              placeholder="Flight Class"
              maxLength="50"
            >
              <option value="">Select Flight Class</option>
              <option value="economy">Economy</option>
              <option value="business">Business</option>
              <option value="first">First Class</option>
            </select>
          </div>
        </div>

      </div>
    </Collapse>
  </>

  const pro_ticket = 
  <>
    <div className="row">
      <div className="col-lg-6 text-left mb-4">
            <ul className="list-unstyled text-left">
              <li><i className="bi bi-check text-success"></i> Real flight data</li>
              <li><i className="bi bi-check text-success"></i> Airline logos in ticket</li>
              <li><i className="bi bi-check text-success"></i> Add additional passengers</li>
              <li><i className="bi bi-check text-success"></i> Choose currency on ticket</li>
              <li><i className="bi bi-check text-success"></i> Choose flight class</li>
            </ul>
            {pro_ticket_custom_settings}
      </div>
      <div className="col-lg-6">
        <ExampleTicket
          headline="Pro Ticket:"
          ticketImage="/images/pro_ticket.png"
        />
      </div>
    </div>
  </>

  const free_ticket_body = 
  <>
    <Row>
      <Col
        align="center">
          {free_ticket}
      </Col>
    </Row>
  </>

  const pro_ticket_body = 
  <>
    <Row>
      <Col
        align="center">
          {pro_ticket}
      </Col>
    </Row>
  </>

  const free_modal_footer =
  <>
    <Button
    size="lg"
    variant="light"
    disabled={isLoading}
    onClick={() => setTabKey("pro")}
    className="text-start w-100 text-center"
    >
      <div className="d-flex align-items-center">
        <div className="flex-shrink-0">
          <i className="bi bi-arrow-left"></i>
        </div>
        <div className="flex-grow-1 text-center">
          Back to Pro Ticket
        </div>
      </div>
    </Button>
    <Button
    size="lg"
    variant="primary"
    disabled={isLoading}
    onClick={!isLoading ? () => handleCheckout("free") : null}
    className="text-start w-100 text-center"
    >
      {isLoading ? 'Processing...' : 'Get Basic Ticket - Free'}
    </Button>
  </>

const pro_modal_footer =
<>
  <Row>
    <Col xs={12}>
    <h5><strong>Total:</strong> 5 €</h5>
    </Col>
    {constClass.ENABLE_COINBASE_PAYMENT &&
    <Col xs={12}>
      <Button
        size="lg"
        variant="primary"
        disabled={isLoadingCoinbase}
        onClick={!isLoadingCoinbase ? () => handleCheckout("coinbase") : null}
        className="text-start w-100 text-center"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-currency-bitcoin" viewBox="0 0 16 16">
          <path d="M5.5 13v1.25c0 .138.112.25.25.25h1a.25.25 0 0 0 .25-.25V13h.5v1.25c0 .138.112.25.25.25h1a.25.25 0 0 0 .25-.25V13h.084c1.992 0 3.416-1.033 3.416-2.82 0-1.502-1.007-2.323-2.186-2.44v-.088c.97-.242 1.683-.974 1.683-2.19C11.997 3.93 10.847 3 9.092 3H9V1.75a.25.25 0 0 0-.25-.25h-1a.25.25 0 0 0-.25.25V3h-.573V1.75a.25.25 0 0 0-.25-.25H5.75a.25.25 0 0 0-.25.25V3l-1.998.011a.25.25 0 0 0-.25.25v.989c0 .137.11.25.248.25l.755-.005a.75.75 0 0 1 .745.75v5.505a.75.75 0 0 1-.75.75l-.748.011a.25.25 0 0 0-.25.25v1c0 .138.112.25.25.25L5.5 13zm1.427-8.513h1.719c.906 0 1.438.498 1.438 1.312 0 .871-.575 1.362-1.877 1.362h-1.28V4.487zm0 4.051h1.84c1.137 0 1.756.58 1.756 1.524 0 .953-.626 1.45-2.158 1.45H6.927V8.539z"/>
        </svg>
        {isLoadingCoinbase ? 'Processing...' : 'Pay with Bitcoin (Coinbase)'}
      </Button>
    </Col>
    }
    {constClass.ENABLE_COINBASE_PAYMENT &&
    <Col xs={12} className="d-flex justify-content-center"><p>or</p></Col>
    }
    {constClass.ENABLE_PAYPAL_PAYMENT &&
    <Col xs={12}>
      <PaypalButton
        currency="EUR"
        showSpinner={true}
        customer_data={props.customer_data}
        flight_data={props.flight_data}
        extra_data={props.extra_data}
        pro_ticket_options={{
          extraPassengers: extraPassengers,
          currencyOnTicket: currency,
          optionalPnrNumber: optionalPnrNumber,
          flightClass: flightClass
        }}
      />
    </Col>
    }
    {constClass.ENABLE_STRIPE_PAYMENT &&
    <Col xs={12}>
      <Button
        size="lg"
        variant="outline-primary"
        disabled={isLoadingStripe}
        onClick={!isLoadingStripe ? () => handleCheckout("stripe") : null}
        className="text-start w-100 text-center"
      >
        <i className="bi bi-credit-card-fill me-2"></i>&nbsp;&nbsp;
        {isLoadingStripe ? 'Processing...' : 'Pay with Creditcard (5 EUR - Stripe)'}
      </Button>
    </Col>
    }
  </Row>
</>

  return (
        <Modal
          show={props.is_visible}
          onHide={props.handleCloseModal}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Choose your ticket
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            className="justify-content-center"
          >
            <Row>
              <Col
                  align="center">
                <Tabs
                  id="controlled-tab-example"
                  activeKey={tabKey}
                  onSelect={(k) => setTabKey(k)}
                  className="mb-3"
                  fill
                  justify
                >
                  <Tab eventKey="pro" title={<span>Pro <i className="bi bi-star-fill text-warning"></i></span>}>
                    {pro_ticket_body}
                  </Tab>
                  <Tab eventKey="basic" title="Basic">
                    {free_ticket_body}
                  </Tab>
                </Tabs>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col>
              {showAlert && (
                <Alert variant={alertType} onClose={() => setShowAlert(false)} dismissible>
                  {alertMessage}
                </Alert>
              )}
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer className="justify-content-center">
              {tabKey == "basic" ? free_modal_footer : pro_modal_footer}
          </Modal.Footer>
        </Modal>
    );
}

export default PayWhatYouWantCheckout;